



































































































































































import { Component, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import BaseAccount from '@/base-components/BaseAccount'
import bus, { SYNC } from '@/utils/bus-event'
import TransactionType from '@/enums/TransactionType'
import queueNotifService from '@/services/QueueNotifService'
import accountService from '@/services/AccountService'
import chartService from '@/services/ChartService'
import balanceService from '@/services/BalanceService'
import transactionService from '@/services/TransactionService'
import exchangeService from '@/services/ExchangeService'
import IAccount from '@/models/IAccount'
import IBalance from '@/models/IBalance'
import ICurrency from '@/models/ICurrency'
import IRefund from '@/models/IRefund'
import IStat from '@/models/IStat'
import ITransaction from '@/models/ITransaction'
import IUser from '@/models/IUser'
import { primary, main, findContrastColor, findDarkValue } from '@/utils'
import couchService from '@/services/CouchService'

@Component({
  components: {
    'account-share': () => import('@/components/AccountShare.vue'),
    'account-transaction-list': () =>
      import('@/components/AccountTransactionList.vue'),
    'earth-map': () => import('@/components/EarthMap.vue'),
    'tag-list': () => import('@/components/TagList.vue'),
    'chart-balance': () => import('@/components/ChartBalance.vue'),
    'account-setting': () => import('@/components/AccountSetting.vue'),
    'online-view': () => import('@/components/OnlineView.vue'),
    'refund-transaction': () => import('@/components/RefundTransaction.vue'),
    'fab-button': () => import('@/components/FabButton.vue')
  }
})
export default class AccountItem extends BaseAccount {
  @Action
  public setTitle!: any
  @Action
  public addAccountId!: any
  public retrieveTransactions: boolean = false
  public transactions: ITransaction[] = []
  public activeTab: string = 'transaction'
  public retrievingExchange: boolean = false

  public async getData(docIds?: string[]): Promise<void> {
    if (docIds && !docIds.find((i: string) => i === this.id)) {
      return
    }
    try {
      if (this.id) {
        this.account = await accountService.get(this.id)
        if (!this.account) {
          queueNotifService.error(`le compte ${this.id} n'existe pas`)
          this.$router.push({ name: 'home' })
          return
        }

        if (this.account.isPublic) {
          this.addAccountId({ accountId: this.id })
          couchService.initLive()
        }
        this.transactions = await transactionService.getAllByAccountId(this.id)
        this.retrieveTransactions = true
        if (document && document.documentElement) {
          if (this.account.color) {
            document.documentElement.style.setProperty(
              '--primary-color',
              this.account.color
            )
            document.documentElement.style.setProperty(
              '--primary-font-color',
              findDarkValue(this.account.color) || main
            )
          } else {
            document.documentElement.style.setProperty(
              '--primary-color',
              primary
            )
            document.documentElement.style.setProperty(
              '--primary-font-color',
              main
            )
          }
        }
        this.setTitle(this.account.name)
      }
    } catch (error) {
      // tslint:disable-next-line
      console.error({ error })
      this.$router.push({ name: 'home' })
      return
    }
  }

  public toggleTab(tab: string): void {
    this.activeTab = tab
  }

  public async retrieveExchange(): Promise<void> {
    if (!this.transactionWithoutExchange.length) {
      return
    }
    this.retrievingExchange = true
    try {
      const transactions: ITransaction[] = [...this.transactionWithoutExchange]
      for (const transaction of transactions) {
        transaction.exchange = await exchangeService.get(
          transaction.mainCurrency.code,
          transaction.date
        )
      }
      await transactionService.multipleSave(transactions)
      queueNotifService.success('Dépenses mises à jour.')
    } catch (error) {
      // tslint:disable-next-line
      console.warn({ error })
    }
    this.retrievingExchange = false
  }

  public totalCostByUserAlias(alias: string): number {
    if (!this.account) {
      return 0
    }
    const transactions: ITransaction[] = this.transactionWithExchange
    return transactionService.getTotalCost(
      transactions,
      this.account.mainCurrency.code,
      alias
    )
  }

  public get totalUserCost(): Array<{ alias: string; total: number }> {
    if (!this.account) {
      return []
    }
    return this.account.users
      .map((user: IUser) => ({
        alias: user.alias || '',
        total: this.totalCostByUserAlias(user.alias || '')
      }))
      .filter((user) => user.total > 0)
  }

  public get showShare(): boolean {
    return !!(
      this.account &&
      this.account.users.length > 1 &&
      this.retrieveTransactions &&
      !this.transactions.length
    )
  }

  public get transactionWithoutRefund(): ITransaction[] {
    if (!this.transactions) {
      return []
    }
    return this.transactions.filter(
      (transaction: ITransaction) =>
        transaction.transactionType === TransactionType.normal
    )
  }

  public get tagCount(): number {
    const tags = new Set(
      this.transactionWithoutRefund.map(
        (transaction: ITransaction) => transaction.tag
      )
    )
    return tags.size
  }

  public get transactionWithExchange(): ITransaction[] {
    if (!this.transactions) {
      return []
    }
    return this.transactions.filter(
      (transaction: ITransaction) => !!transaction.exchange
    )
  }

  public get transactionWithoutExchange(): ITransaction[] {
    if (!this.transactions) {
      return []
    }
    return this.transactions.filter(
      (transaction: ITransaction) => !transaction.exchange
    )
  }

  public get userStats(): IStat[] {
    const totalCost: number = this.totalCost
    if (!this.account || totalCost === 0) {
      return []
    }
    const account: IAccount = this.account
    const transactions: ITransaction[] = this.transactionWithExchange
    const mainCurrency: ICurrency = account.mainCurrency
    return this.account.users.map((user: IUser) => {
      const userCost: number = transactionService.getTotalCost(
        transactions,
        account.mainCurrency.code,
        user.alias
      )
      const percent: number = Math.round((userCost / totalCost) * 100)
      return {
        label: user.alias || '',
        value: userCost,
        percent,
        balance: balanceService.getBalanceByUser(
          user,
          mainCurrency,
          transactions
        )
      }
    })
  }

  public get locations() {
    return this.transactions
      .filter((transaction) => transaction.location)
      .map((transaction) => transaction.location)
  }

  public get myTotalCost(): number {
    if (!this.account) {
      return 0
    }
    const transactions: ITransaction[] = this.transactionWithExchange
    return transactionService.getTotalCost(
      transactions,
      this.account.mainCurrency.code,
      this.userAlias
    )
  }

  public get totalCost(): number {
    if (!this.account) {
      return 0
    }
    const transactions: ITransaction[] = this.transactionWithExchange
    return transactionService.getTotalCost(
      transactions,
      this.account.mainCurrency.code
    )
  }

  public get userBalance(): IBalance[] {
    if (!this.account || !this.account.users) {
      return []
    }
    const mainCurrency: ICurrency = this.account.mainCurrency
    const transactions: ITransaction[] = this.transactionWithExchange
    return this.account.users.map((user: IUser) =>
      balanceService.getBalanceByUser(user, mainCurrency, transactions)
    )
  }

  public get userRefunds(): IRefund[] {
    if (!this.account) {
      return []
    }
    return balanceService.getRefund(this.userBalance)
  }

  public get isAdmin(): boolean {
    if (!this.account || !this.account.admin || !this.user) {
      return true
    }
    return this.account.admin.slugEmail === this.user.slugEmail
  }

  public get userAlias(): string {
    if (!this.account || !this.user) {
      return ''
    }
    const mainUser = this.user
    const user = this.account.users.find(
      (u: IUser) => u.slugEmail === mainUser.slugEmail
    )
    return (user && user.alias) || ''
  }

  public get isEncrypted(): boolean {
    return !!(this.account && this.account.name.length > 30)
  }

  public get backgroundColor(): any | null {
    if (!this.account || !this.account.color) {
      return null
    }
    return {
      backgroundColor: this.account.color,
      color: findContrastColor(this.account.color) || 'black'
    }
  }

  public get isMultiUser(): boolean {
    return !!this.account && this.account.users.length > 1
  }
}
